import { ThemeEvents } from '@theme/events';

/**
 * <pix-price>
 *
 * Mantém o valor no PIX sincronizado com a variante selecionada.
 *
 * O cálculo do desconto continua no servidor (Liquid), a partir do preço da
 * variante selecionada. No evento `variant:update`, trocamos o container do
 * valor pelo recém-renderizado presente em `event.detail.data.html` — mesmo
 * mecanismo usado pelo `<product-price>` do tema.
 */
class PixPrice extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.updateValue);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateValue);
  }

  /**
   * @param {CustomEvent} event - O evento variant:update.
   */
  updateValue = (event) => {
    const data = event.detail?.data;
    if (!data?.html) return;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const updated = data.html.querySelector(`pix-price[data-block-id="${this.dataset.blockId}"]`);
    if (!updated) return;

    const newContainer = updated.querySelector('[ref="pixContainer"]');
    const currentContainer = this.querySelector('[ref="pixContainer"]');
    if (newContainer && currentContainer) currentContainer.replaceWith(newContainer);
  };
}

if (!customElements.get('pix-price')) {
  customElements.define('pix-price', PixPrice);
}
